import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
export function NoirAtelierPromo() {
  return <section className="relative w-full bg-dark-900 py-24 md:py-32 overflow-hidden" data-id="element-113">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] bg-gold/[0.04] rounded-full blur-[100px] pointer-events-none" data-id="element-114" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="relative rounded-2xl overflow-hidden border border-white/5" data-id="element-116">
          {/* Background image */}
          <div className="absolute inset-0" data-id="element-117">
            <img src="https://cdn.magicpatterns.com/uploads/sZVjrUyD2zp5HNuMCu6CBm/WhatsApp_Image_2026-04-03_at_12.38.52_AM.jpg" alt="Kia PV5 Noir Atelier with pop-top roof raised" className="w-full h-full object-cover" data-id="element-118" />
            <div className="absolute inset-0 bg-gradient-to-r from-dark-900 via-dark-900/85 to-dark-900/40" data-id="element-119" />
          </div>

          {/* Content */}
          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-10 p-10 md:p-16" data-id="element-120">
            <div className="max-w-xl" data-id="element-121">
              <p className="text-gold/60 text-xs font-semibold tracking-[0.5em] uppercase mb-4 font-body" data-id="element-122">
                Flagship Conversion
              </p>
              <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight mb-3" data-id="element-123">
                PV5 <span className="text-gold" data-id="element-124">NOIR</span> ATELIER
              </h2>
              <p className="font-display text-lg text-white/50 italic mb-6" data-id="element-125">
                Designed to Live Beautifully.
              </p>
              <p className="text-white/40 text-sm font-body leading-relaxed mb-8" data-id="element-126">
                A minimalist luxury campervan conversion inspired by
                architectural interiors, boutique hotels, and modern automotive
                design language. Explore the full spec sheet, interior palette,
                lighting system, and layout configuration.
              </p>
              <Link to="/noir-atelier" className="inline-flex items-center gap-3 px-8 py-4 bg-gold text-dark-900 font-semibold text-sm tracking-widest uppercase rounded hover:bg-gold-hover transition-all duration-300 hover:shadow-lg hover:shadow-gold/20 group" data-id="element-127">
                View Full Spec Sheet
                <ArrowRightIcon size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-128" />
              </Link>
            </div>

            {/* Highlight specs */}
            <div className="grid grid-cols-2 gap-3 flex-shrink-0" data-id="element-129">
              {[{
              label: 'Design',
              value: 'Japandi Calm'
            }, {
              label: 'Palette',
              value: 'Stone Ivory & Oak'
            }, {
              label: 'Lighting',
              value: '2700K Ambient'
            }, {
              label: 'Layout',
              value: '3-Zone Flow'
            }].map((item, i) => <div key={i} className="bg-dark-900/60 backdrop-blur-sm border border-white/5 rounded-lg p-4 text-center min-w-[120px]" data-id="element-130">
                  <p className="text-gold text-xs uppercase tracking-widest mb-1 font-body" data-id="element-131">
                    {item.label}
                  </p>
                  <p className="text-white/80 text-sm font-display font-semibold" data-id="element-132">
                    {item.value}
                  </p>
                </div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}